// 📄 hooks/useUnreadChats.ts
// Cantidad de chats con novedades (no la cantidad total de mensajes sin
// leer, ver tieneNoLeidos en chatService.ts) — para el badge del ícono de
// Mensajes en el navbar.
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext.tsx';
import { subscribeMisChats, tieneNoLeidos } from '../services/chatService.ts';

export function useUnreadChats(): number {
  const { user } = useAuth();
  const [cantidad, setCantidad] = useState(0);

  useEffect(() => {
    if (!user) { setCantidad(0); return; }
    const unsubscribe = subscribeMisChats(user.uid, (chats) => {
      setCantidad(chats.filter((c) => tieneNoLeidos(c, user.uid)).length);
    });
    return () => unsubscribe();
  }, [user]);

  return cantidad;
}
